import React, { Component } from "react";
import { Layout, Popover, Row, Col, Icon } from "antd";
import { isEmpty } from 'lodash';

import Sidebar from "../Sidebar/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";
import { Link } from "react-router-dom";
import { AuthenticationMenu } from 'src/helpers/Authorization';
import Topbar from "../Topbar/index";
import { footerText } from "util/config";
import App from "routes/index";
import { connect } from "react-redux";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import { vaiTros as VaiTro, listVaiTro } from 'src/helpers/Authorization';
import Permission from "src/helpers/Permission";

const { Content, Footer } = Layout;

export class MainApp extends Component {
  state = {
    vaiTroAvailble: false,
    activedVaiTro: {}
  }

  getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return ""
    }
  };
  getNavStyles = (navStyle, userInfo, activedVaiTro) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar userInfo={userInfo} activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_DRAWER:
        return <Topbar userInfo={userInfo} activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar userInfo={userInfo} activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };
  getSidebar = (navStyle, width, activedVaiTro) => {
    if (width < TAB_SIZE) {
      return <Sidebar activedVaiTro={activedVaiTro} />;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_DRAWER:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      default:
        return null;
    }
  };

  async UNSAFE_componentWillMount() {
    const { authUser, vaiTro } = this.props;
    const authInfo = { authUser, vaiTro };
    const { vaiTroAvailble } = this.state;
    if (!isEmpty(authUser) && !isEmpty(vaiTro.content) && !vaiTroAvailble) {
      const activedVaiTro = await this.xuLyVaiTro(authInfo);
      await this.setState({ vaiTroAvailble: true, activedVaiTro });
    }
  }

  async componentDidUpdate() {
    const { authUser, vaiTro } = this.props;
    const authInfo = { authUser, vaiTro };
    const { vaiTroAvailble } = this.state;
    if (!isEmpty(authUser) && !isEmpty(vaiTro.content) && !vaiTroAvailble) {
      const activedVaiTro = await this.xuLyVaiTro(authInfo);
      await this.setState({ vaiTroAvailble: true, activedVaiTro });
    }
  }

  /**
  * Xử lý vai trò sẽ được sử dụng trong ứng dụng
  *
  * @param {*} values
  * @returns
  */
  xuLyVaiTro = async (values) => {
    const vaiTro = await listVaiTro(values.authUser);
    const activedVaiTro = await VaiTro(values.vaiTro.content, vaiTro);
    return activedVaiTro;
  }

  render() {
    const { match, width, navStyle, authUser } = this.props;
    const { activedVaiTro } = this.state;
    const heThong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QTHT]);
    const bieuMauChiTieu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLCN, Permission.QL_BM_CT]);
    const heThongMenuOptions = (
      <div className="menu-setting">
        {heThong && <p><Link to="/he-thong/quyen"><Icon type="hdd" /> Quyền</Link></p>
        }
        {heThong && <p><Link to="/he-thong/phong-ban"><Icon type="team" /> Phòng ban</Link></p>
        }
        {heThong && <p><Link to="/he-thong/chuc-vu"><Icon type="exception" /> Chức vụ</Link></p>
        }
        {heThong && <p><Link to="/he-thong/vai-tro"><Icon type="solution" /> Vai trò</Link></p>
        }
        {heThong && <p><Link to="/he-thong/nguoi-dung"><Icon type="user" /> Người dùng</Link></p>
        }
      </div>
    );
    const chiTieuMenuOptions = (
      <div className="menu-setting">
        {bieuMauChiTieu && <p><Link to="/danh-muc/bao-cao-cum-cong-nghiep/bieu-mau-ccn"><Icon type="hdd" /> Biểu mẫu CCN</Link></p>
        }
        {bieuMauChiTieu && <p><Link to="/danh-muc/bao-cao-cum-cong-nghiep/chi-tieu-ccn"><Icon type="team" /> Chỉ tiêu CCN</Link></p>
        }
      </div>
    );
    // const userInfo = getCookieValue('userInfo');
    return (
      <Layout className="gx-app-layout">
        {this.getSidebar(navStyle, width, activedVaiTro)}
        <Layout>
          {this.getNavStyles(navStyle, authUser, activedVaiTro)}
          <Content className={`gx-layout-content ${this.getContainerClass(navStyle)}`}>
            <App match={match} activedVaiTro={activedVaiTro} />
            <Footer>
              <div className="gx-layout-footer-content">
                <Row>
                  <Col xs={18} lg={22}>{footerText}</Col>
                  {bieuMauChiTieu &&
                    <Col xs={3} lg={1}>
                      <div>
                        <Popover placement="bottomRight" content={chiTieuMenuOptions} trigger="click">
                          <span title="Biểu mẫu - Chỉ tiêu">
                            <i className="icon far fa-file-alt fa-lg"></i>
                          </span>
                        </Popover>
                      </div>
                    </Col>
                  }
                  {heThong &&
                    <Col xs={3} lg={1}>
                      <Popover placement="bottomRight" content={heThongMenuOptions} trigger="click">
                        <span title="Hệ thống"><i className="icon icon-setting fa-lg" /></span>
                      </Popover>
                    </Col>
                  }
                </Row>
              </div>
            </Footer>
          </Content>
        </Layout>
      </Layout >
    )
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { width, navStyle } = settings;
  const { authUser, vaiTro } = auth;
  return { width, navStyle, authUser, vaiTro }
};
export default connect(mapStateToProps)(MainApp);

